import React from "react";
import { Link } from "react-router-dom";

import SignUp from "@/components/SignUp";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";

const SignUpPage: React.FC = () => {
    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-muted/20 px-4">
            <Card className="w-full max-w-md">
                <CardContent className="p-6 space-y-6">
                    {/* Form */}
                    <SignUp />

                    <Separator />

                    {/* Footer link */}
                    <div className="text-center text-sm text-muted-foreground">
                        <span className="mr-1">Уже есть аккаунт?</span>
                        <Button
                            asChild
                            variant="link"
                            className="px-1 h-auto"
                        >
                            <Link to="/signin">Войти</Link>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default SignUpPage;
